const OVERFLOW_STYLES = ['auto', 'scroll']

export const findParentScroll = (node) => {
  try {
    let parent = node.parentNode
    if (parent && parent instanceof Element) {
      const hasHorizontalScrollbar = parent.scrollWidth > parent.clientWidth
      const hasVerticalScrollbar = parent.scrollHeight > parent.clientHeight
      const isInWhiteList = parent.classList ? !parent.classList.contains('ft--control--root') : true
      const style = getComputedStyle(parent)
      const isGoodStyle = OVERFLOW_STYLES.includes(style.overflowX) || OVERFLOW_STYLES.includes(style.overflowY)
      if ((hasHorizontalScrollbar || hasVerticalScrollbar) && isInWhiteList && isGoodStyle) {
        return parent
      } else {
        return findParentScroll(parent)
      }
    } else {
      return null
    }
  } catch (error) {
    console.error(error)
  }
  return null
}
